import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { HERO, RESTAURANT } from "../mock";
import HeroVideoBg from "./HeroVideoBg";

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-10 overflow-hidden">
      {/* Muted background video — plays once per visit, then disappears */}
      <HeroVideoBg />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          {/* Left copy */}
          <div className="reveal">
            <span className="label-mono text-[#D5521B]">{RESTAURANT.eyebrow}</span>
            <h1 className="font-display font-black leading-[0.92] text-[#16110E] mt-5 text-[13vw] sm:text-7xl lg:text-[5.4rem]">
              {HERO.heading}
              <span className="block italic font-medium text-[#1493C4] text-[9vw] sm:text-5xl lg:text-[3.6rem] mt-1">
                {HERO.script}
              </span>
              <span className="block text-[#D5521B] text-[10vw] sm:text-6xl lg:text-[4.2rem] mt-1">
                {HERO.accent}
              </span>
            </h1>
            <p className="mt-7 text-[#5E5548] text-lg leading-relaxed max-w-md">
              {HERO.blurb}
            </p>
            <div className="mt-9 flex flex-wrap gap-4">
              <a
                href="#menu"
                className="btn-primary inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold"
              >
                See the Menu <ArrowRight size={17} />
              </a>
              <a
                href={RESTAURANT.phoneHref}
                className="btn-ghost inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold"
              >
                <Phone size={16} /> Call &amp; Order
              </a>
            </div>
          </div>

          {/* Right image collage */}
          <div className="reveal relative" style={{ transitionDelay: "0.15s" }}>
            <div className="relative rounded-[26px] overflow-hidden ticket-edge bg-[#FBF6EA] p-2.5 shadow-[0_30px_60px_-30px_rgba(60,40,20,0.5)]">
              <div className="overflow-hidden rounded-[18px]">
                <img
                  src={HERO.plate.img}
                  alt="Uncle Willie's Sunday plate"
                  className="img-zoom w-full h-[340px] md:h-[430px] object-cover"
                />
              </div>
              <div className="flex items-center justify-between px-3 pt-3 pb-1.5">
                <span className="label-mono text-[#16110E]">
                  {HERO.plate.no} · {HERO.plate.label}
                </span>
                <span className="label-mono text-[#D5521B]">{HERO.plate.status}</span>
              </div>
            </div>

            {/* Floating side cards */}
            <div className="absolute bottom-16 -left-5 sm:-left-8 w-32 sm:w-40 rotate-[-6deg] rounded-2xl overflow-hidden ticket-edge bg-[#FBF6EA] p-1.5 shadow-xl hidden sm:block z-10">
              <img
                src={HERO.side1.img}
                alt={HERO.side1.label}
                className="w-full h-24 sm:h-28 object-cover rounded-xl"
              />
            </div>
            <div className="absolute -top-6 -right-3 w-28 sm:w-36 rotate-[7deg] rounded-2xl overflow-hidden ticket-edge bg-[#FBF6EA] p-1.5 shadow-xl hidden sm:block">
              <img
                src={HERO.side2.img}
                alt={HERO.side2.label}
                className="w-full h-20 sm:h-24 object-cover rounded-xl"
              />
            </div>
          </div>
        </div>

        {/* Info ticker bar */}
        <div className="reveal mt-16 md:mt-20 border-y border-[#DCCFB4] py-5">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-center">
            {HERO.ticker.map((t, i) => (
              <React.Fragment key={t}>
                <span className="font-mono text-xs md:text-sm uppercase tracking-wider text-[#16110E]">
                  {t}
                </span>
                {i < HERO.ticker.length - 1 && (
                  <span className="text-[#D5521B] text-xs">◆</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
